import type { ActionContext } from 'vuex'

import type {
  ActionClass,
  InstanceManagementState,
  InstanceSearchServiceConfig,
} from '../../../models'
import type { InstanceSearchManagementService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { INSTANCE_MANAGEMENT_CONSTS } from '../instance-management.consts'

export class UpdateSearchServiceConfigAction implements ActionClass {
  static async execute(
    this: void,
    { commit }: ActionContext<InstanceManagementState, any>,
    { config, instance }: { config: InstanceSearchServiceConfig; instance: string },
  ): Promise<InstanceSearchServiceConfig> {
    const instanceSearchServiceConfig = CONTAINER.get<InstanceSearchManagementService>(
      TYPES.InstanceSearchManagementService,
    )
    const updatedConfig = await instanceSearchServiceConfig.updateConfig(instance, config)
    commit(INSTANCE_MANAGEMENT_CONSTS.mutations.setSearchServiceConfig, updatedConfig)
    return updatedConfig
  }
}
